// frontend/user/src/components/file-thumb.tsx
import { fileKind, FileIcon } from './file-icon'
import { thumbUrl } from '../_lib/thumb-url'
import type { FileRow } from '../_lib/offline-cache'

export type ThumbSource = { signed: string | null | undefined; baseFileId: string; name: string }

/** 决定一行的缩略图源；返回 null 表示无缩略图（调用方回退到 FileIcon）。
 *  signed = 后端签好的缩略图 URL(图片用自身 thumb_url_list；视频/封面用 cover 行同名计算列)。 */
export function thumbSourceOf(row: FileRow): ThumbSource | null {
  const kind = fileKind(row.type, { mimeType: row.mime_type, name: row.name })
  if (kind === 'image') {
    return row.base_file_id
      ? { signed: row.thumb_url_list, baseFileId: row.base_file_id, name: row.name }
      : null
  }
  if (kind === 'video' || kind === 'audio' || kind === 'folder') {
    if (row.cover?.base_file_id) {
      return { signed: row.cover.thumb_url_list, baseFileId: row.cover.base_file_id, name: row.cover.name }
    }
    return null
  }
  return null
}

export function FileThumb({ row, size = 44 }: { row: FileRow; size?: number }) {
  const src = thumbSourceOf(row)
  const kind = fileKind(row.type, { mimeType: row.mime_type, name: row.name })

  if (!src) {
    return <FileIcon type={row.type} name={row.name} mimeType={row.mime_type} size={size} />
  }

  const url = thumbUrl(src.signed, src.baseFileId, src.name)

  if (kind === 'folder') {
    // 文件夹外框内嵌封面图：蓝底圆角框 + 顶部小页签 + 下方裁切封面
    return (
      <span
        className="relative flex shrink-0 overflow-hidden rounded-lg bg-[#E8F1FF]"
        style={{ width: size, height: size }}
        data-file-kind="folder"
        data-has-cover="true"
        aria-hidden="true"
      >
        <span className="absolute left-1 top-0 h-2 w-4 rounded-t-sm bg-[#1971ca]/30" />
        <img src={url} alt="" loading="lazy" className="mt-2 h-[calc(100%-0.5rem)] w-full rounded-b-md object-contain" />
      </span>
    )
  }

  return (
    <span
      className="relative flex shrink-0 overflow-hidden rounded-lg bg-[#F1F2F4]"
      style={{ width: size, height: size }}
      data-file-kind={kind}
      data-has-cover="true"
      aria-hidden="true"
    >
      <img src={url} alt="" loading="lazy" className="h-full w-full object-contain" />
      {kind === 'video' && (
        <span className="absolute inset-0 flex items-center justify-center">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="white" className="drop-shadow">
            <path d="M8 5v14l11-7z" />
          </svg>
        </span>
      )}
    </span>
  )
}
